import { Item } from '../../../../../../utils/types/generals'
import { searchInModeLower } from '../../../../../../utils/validate/validate'


const useFilter = () => {

  const filterRow = ({ value, list }: { value: Record<string, unknown>; list: any[] }) => {

    const filterApllied = list?.filter((itemFilter) => {
      const roles = value?.role as Item[]
      const userTypes = value?.userType as Item[]
      const search = itemFilter.name
      const area = value?.area as Item[]
      const department = value?.department as Item[]
      const areaIds = itemFilter.areaName?.toString().split(',').map((id: string) => id.trim());
      const departmentIds = itemFilter.departmentName?.toString().split(',').map((id: string) => id.trim());

      const rolesExist = !!roles?.length ? roles?.some((itemRoles) => itemRoles.value == itemFilter.role) : true
      const userTypesExist = !!userTypes?.length ? userTypes?.some((itemUserType) => itemUserType.value == itemFilter.userType) : true
      const areaExist = !!area?.length ? area.some((itemAreas) => areaIds.includes(itemAreas.label.toString())) : true;
      const departmentExist = !!department?.length ? department.some((itemDepartments) => departmentIds.includes(itemDepartments.label.toString())) : true;
      const searchExist = searchInModeLower(search, value.search as string)

      return !!rolesExist && !!userTypesExist && !!searchExist && !!areaExist && !!departmentExist
    })

    return filterApllied
  }

  return { filterRow }
}

export { useFilter }
